module.exports = __webpack_public_path__ + "img/FR14078.71b5e4e6.png";